import { useDispatch } from 'react-redux';

import { removeLastSelectedFlight } from '@entities/exchange';

export function useRemoveLastSelectedFlight() {
	const dispatch = useDispatch();

	const onRemoveLastSelectedFlight = () => {
		dispatch(removeLastSelectedFlight());
	};

	return { onRemoveLastSelectedFlight };
}
